/**
 * Constant variables used throughout the application.
 * @since 2/19/18
 * @file
 */

module.exports = Object.freeze({
	// The name of the storage key to set when there is an Auth0 error
	AUTH_ERROR_STORAGE_NAME: "authentication_error",

	// Storage token name for dialog count
	DIALOG_RENDER_COUNT_NAME: "dialog_rendered_count",
	// The place to redirect the user to if they land on an
	// authenticated page and aren't logged in.
	UNAUTHENTICATED_REDIRECT_PATH: "/permits/login",
	APPLICATION_STATUSES: {
		PENDING: "pending",
		PROCESSING: "processing",
		FAILED: "failed",
		COMPLETED: "completed",
	},
	PERMIT_STATUSES: {
		PENDING: "pending",
		UNPAID: "unpaid",
		ISSUED: "issued",
		WAITLISTED: "waitlisted",
		OFFERED: "offered",
		ACTIVE: "active",
		CANCELLED: "cancelled",
		SUSPENDED: "suspended",
		EXPIRED: "expired",
		REJECTED: "rejected",
		DELETED: "deleted",
	},
	BOOKING_REJECTION_CODES: {
		NO_PASSES_REMAINING: "no_passes_remaining",
		SIMULTANEOUS_LIMIT_REACHED: "simultaneous_limit_reached",
	},
	PASS_ERROR_CODES: {
		PASS_VEHICLE_EVENT_FAILED: "pass_vehicle_event_failed",
	},
	THIRD_PARTY_LPN_REFUSAL_REASONS: {
		FAILED: "third_party_lpn_failed",
		ERROR: "third_party_lpn_error",
	},
	APPROVAL_STATUSES: {
		PENDING: 0,
		NEEDS_INFO: 1,
		APPROVED: 2,
		REJECTED: 3,
	},
	APPROVAL_SUB_STATUSES: {
		DOCUMENTS_REQUESTED: "documents_requested",
		DOCUMENTS_UPLOADED: "documents_uploaded",
	},
	SUB_STATUSES: {
		ACH_PENDING: "ach_pending",
	},
	PERMIT_TYPE_VISIBILITIES: {
		ALL: "all",
		CUSTOMER: "customer",
	},
	CYCLE_TYPES: {
		fixed: "fixed",
	},
	CART_TYPES: {
		application: "permit_application",
		permit: "permit_extension",
		offer: "permit_offer",
		unpaid: "permit_pay",
		pass_added: "permit_pass_add",
		change_request_application: "change_request_application",
		waitlist: "permit_waitlist_extension",
	},
	CART_STORAGE_DAYS: 2,
	VEHICLE_CHANGE_REQUEST_TYPES: {
		ADDED: "added",
		REMOVED: "removed",
		EDITED: "edited",
	},
	CHARGE_TYPES: {
		CHARGE_PER_PERMIT: "per_permit",
		CHARGE_PER_ORDER: "per_order",
	},
	PAYMENT_CARD_PAYMENT: {
		americanexpress: "Amex",
		discover: "Discover",
		mastercard: "Mastercard",
		visa: "Visa",
		jcb: "JCB",
		unionpay: "UnionPay",
	},
	PASSPORT_HOME_PAGE: "http://oakpark.localhost:40538/",
	FREE_RATE_ID: "free_rate",
	INTERCOM_APP_ID: process.env.INTERCOM_APP_ID || "ut6l4e94",

	// Lets a local build skip the ACH captcha, which is friction without protection there: the
	// dev PCI ACH route does not enforce the WAF challenge, so an empty X-Aws-Waf-Token is
	// accepted. Gated on the local stage as well as the flag because a real shell var outranks
	// config/env.js — the stage check is what keeps this from ever taking effect in a deployed
	// build. Override with ACH_CAPTCHA_DISABLED=false to exercise the widget locally.
	ACH_CAPTCHA_DISABLED: process.env.PASSPORT_ENV === "local" && String(process.env.ACH_CAPTCHA_DISABLED) === "true",
});
